import dayjs from 'dayjs';
import { type EventApplicationEntrypointContextDataFragment } from '../../../../api/fragments';
import { type EventDataFragment } from '../../../../api/fragments/EventData';
import OcrFilesManager from '../../../../components/ocr/OcrFilesManager';
import LeadGenFormUnavailableResult from '../../../../components/results/LeadGenFormUnavailableResult';
import UserSessionExpireModal from '../../../../components/UserSessionExpireModal';
import EventEntrypointInner from './EventEntrypointInner';
import { EventJourneyKycAndAgreementProvider } from './EventJourneyKycAndAgreement';
import { EventJourneySetupProvider } from './EventJourneySetup';

type EventExpiredProps = {
    endpoint: EventApplicationEntrypointContextDataFragment;
    event: EventDataFragment;
    eventName: string;
};

const EventExpired = ({ endpoint, event, eventName }: EventExpiredProps) => {
    // if event is expired, return expiry page
    if (dayjs().isAfter(event.period.end)) {
        return <LeadGenFormUnavailableResult eventName={eventName} />;
    }

    // if event is not expired, return form
    return (
        <OcrFilesManager>
            {event.privateAccess && <UserSessionExpireModal />}
            <EventJourneySetupProvider endpoint={endpoint} event={event}>
                <EventJourneyKycAndAgreementProvider>
                    <EventEntrypointInner />
                </EventJourneyKycAndAgreementProvider>
            </EventJourneySetupProvider>
        </OcrFilesManager>
    );
};

export default EventExpired;
